import useRoutes from 'src/routes/useRoutes';
import { useEffect } from 'react';
function usePageTitle() {
    const { selectedRoute } = useRoutes();
    const pageTitle = selectedRoute
        ? selectedRoute.name
        : '';
    useEffect(() => {
        document.title = pageTitle
            ? `${pageTitle} - CompuAccess`
            : 'CompuAccess';
    }, [pageTitle]);
}
export default usePageTitle;
